import './pageTopBlock/breadcrumbs/breadcrumbs.css';
import './pageTopBlock/hotelDetails/hotelDetails.css';
import '@/js/common/components/reviewsColor/reviewsColor.css';
import './pageTopBlock/hotelContent/hotelContent.css';
import './hotelContent/filterGroup/filterGroup.scss';
import './hotelContent/hotelTourList/hotelTourList.scss';
import './aboutHotel/aboutHotel.scss';
import './hotelMap/hotelMap.scss';
import './similar-hotels/similar-hotels.css';
import './advantages/advantages.css';
import './progressBar/progressBar.scss';
import './hotel.scss';
